import jwtDecode from 'jwt-decode';

/**
 * Verifica si un token es expirado. Se usa para los tokens generado con el proceso de autenticación legacy de Helios API.
 * @param token
 * @returns true si es expirado, false en caso contrario
 */
export function isHeliosLegacyTokenExpired(token: string): boolean {
  try {
    const { exp } = jwtDecode<{ exp: number }>(token);

    return exp * 1000 < Date.now();
  } catch {
    return true; // formato inválido => trátalo como expirado
  }
}
